export const SET_ERROR = 'SET_ERROR'
export const SET_INFO = 'SET_INFO'
export const CLEAR_ERROR = 'CLEAR_ERROR'
export const CLEAR_INFO = 'CLEAR_INFO'

export const SET_RESOURCES_LOADING = 'SET_RESOURCES_LOADING'
export const SET_RESOURCES = 'SET_RESOURCES'
export const SET_RESOURCES_SLICED = 'SET_RESOURCES_SLICED'
export const SET_RESOURCES_TAGGED = 'SET_RESOURCES_TAGGED'
export const SET_RESOURCES_VIEW = 'SET_RESOURCES_VIEW'
export const SET_RESOURCES_FILTER = 'SET_RESOURCES_FILTER'
export const SET_RESOURCE_ACTIVE = 'SET_RESOURCE_ACTIVE'
export const CLEAR_RESOURCES_VIEW = 'CLEAR_RESOURCES_VIEW'
export const SET_RESOURCE = 'SET_RESOURCE'
export const SET_RESOURCE_ID = 'SET_RESOURCE_ID'
export const ADD_RESOURCE_REFERENCE = 'ADD_RESOURCE_REFERENCE'
export const REMOVE_RESOURCE_REFERENCE = 'REMOVE_RESOURCE_REFERENCE'
export const RESET_RESOURCE = 'RESET_RESOURCE'
export const CLEAR_RESOURCE = 'CLEAR_RESOURCE'
export const CLEAR_RESOURCE_CODE = 'CLEAR_RESOURCE_CODE'
export const SET_RESOURCE_SEARCH = 'SET_RESOURCE_SEARCH'
export const SET_RESOURCE_SEARCH_TAG = 'SET_RESOURCE_SEARCH_TAG'
export const CLEAR_RESOURCE_SEARCH = 'CLEAR_RESOURCE_SEARCH'
export const SET_RESOURCE_HTML = 'SET_RESOURCE_HTML'
export const SET_TAGS = 'SET_TAGS'
export const SET_DOWNLOAD_FILE = 'SET_DOWNLOAD_FILE'
export const SET_RESOURCE_META = 'SET_RESOURCE_META'
export const TOGGLE_DIALOG_DETAILS = 'TOGGLE_DIALOG_DETAILS'

export const SET_CATEGORIES = 'SET_CATEGORIES'
export const SET_CATEGORY = 'SET_CATEGORY'

export const SET_USER_LOADING = 'SET_USER_LOADING'
export const SET_USERS = 'SET_USERS'
export const SET_USERS_SORTED = 'SET_USERS_SORTED'
export const SET_USER = 'SET_USER'
export const SET_USER_ID = 'SET_USER_ID'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const SET_USER_RESOURCES = 'SET_USER_RESOURCES'
export const SET_USER_FAVORITES = 'SET_USER_FAVORITES'
export const TOGGLE_DIALOG_LOGIN = 'TOGGLE_DIALOG_LOGIN'
export const TOGGLE_DIALOG_PASSWORD = 'TOGGLE_DIALOG_PASSWORD'
export const TOGGLE_DIALOG_DELETE_USER = 'TOGGLE_DIALOG_DELETE_USER'
export const SET_USER_ERROR = 'SET_USER_ERROR'
export const CLEAR_USER_ERROR = 'CLEAR_USER_ERROR'
export const TOGGLE_CONTACT_FORM = 'TOGGLE_CONTACT_FORM'